module.exports = __webpack_public_path__ + "img/suspended-checkmark.ae0e2094.png";